import React from 'react';
import { SvgIcon } from '@material-ui/core';

interface ThemeFilterIconProps {
    color?: string;
}

export const ThemeFilterIcon = (props: ThemeFilterIconProps): JSX.Element => {
    const { color } = props;
    return (
        <SvgIcon viewBox='0 0 12 12'>
            <path
                d='M0.833452 1.74C2.18012 3.46667 4.66679 6.66667 4.66679 6.66667V10.6667C4.66679 11.0333 4.96678 11.3333 5.33345 11.3333H6.66679C7.03345 11.3333 7.33345 11.0333 7.33345 10.6667V6.66667C7.33345 6.66667 9.81345 3.46667 11.1601 1.74C11.5001 1.3 11.1868 0.666668 10.6335 0.666668H1.36012C0.806785 0.666668 0.493452 1.3 0.833452 1.74Z'
                fill={color || '#2C3E49'}
            />
        </SvgIcon>
    );
};
